export class SpUiConfigService {
    private static CONFIG: SpUiConfig = {
        SP_STATIC_ASSET_HOST: window['SP_CONFIG_STATIC_ASSET_HOST'] ?? 'https://www.spotteron.com/assets/map',
        SP_TOPIC_ASSET_HOST: window['SP_CONFIG_TOPIC_ASSET_HOST'] ?? 'https://www.spotteron.com/assets/map/config/crowdwater',
        SP_FILE_HOST: window['SP_CONFIG_FILE_HOST'] ?? 'https://files.spotteron.com',
        SP_WIKIMEDIA_URI: window['SP_CONFIG_WIKIMEDIA_URI'] ?? 'https://commons.wikimedia.org/wiki/Special:FilePath',
        SP_TOPIC: window['SP_CONFIG_TOPIC'] ?? 'crowdwater'
    };

    public static set(config: Partial<SpUiConfig>): void {
        SpUiConfigService.CONFIG = {
            ...SpUiConfigService.CONFIG,
            ...config
        }
    }

    public static get(key: keyof SpUiConfig) {
        return SpUiConfigService.CONFIG[key];
    }
}

export interface SpUiConfig {
    SP_STATIC_ASSET_HOST: string;
    SP_TOPIC_ASSET_HOST: string;
    SP_FILE_HOST: string;
    SP_WIKIMEDIA_URI: string;
    SP_TOPIC: string;
}
